<template>
    <div class="sidebar">
        <el-menu
                :collapse="collapse"
                :default-active="onRoutes"
                active-text-color="#20a0ff"
                background-color="#324157"
                class="sidebar-el-menu"
                router
                text-color="#bfcbd9"
                unique-opened
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu
                                    :index="subItem.index"
                                    :key="subItem.index"
                                    v-if="subItem.subs"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                        :index="threeItem.index"
                                        :key="i"
                                        v-for="(threeItem,i) in subItem.subs"
                                >{{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                    :index="subItem.index"
                                    :key="subItem.index"
                                    v-else
                            >{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';

    export default {
        data() {
            return {
                collapse: false,
                items: [
                    {
                        icon: 'el-icon-lx-home',
                        index: 'home',
                        title: '系统首页'
                    },
                    {
                        icon: 'el-icon-s-order',
                        index: 'order',
                        title: '订单管理'
                    },
                    {
                        icon: 'el-icon-lx-camera',
                        index: '1',
                        title: '景区/门票',
                        subs: [
                            {
                                index: 'scenic',
                                title: '景区管理'
                            },
                            {
                                index: 'ticket',
                                title: '门票管理'
                            },
                            {
                                index: 'scenicmenu',
                                title: '景点分类管理'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-document-copy',
                        index: 'article',
                        title: '内容管理'
                    },
                    {
                        icon: 'el-icon-food',
                        index: 'food',
                        title: '美食管理'
                    },

                    {
                        icon: 'el-icon-office-building',
                        index: '2',
                        title: '酒店管理',
                        subs: [
                            {
                                index: 'hotel',
                                title: '酒店管理'
                            },
                            {
                                index: 'hotelarea',
                                title: '酒店区域管理'
                            }
                        ]
                    },
                    {
                        icon: 'el-icon-attract',
                        index: 'keywords',
                        title: '关键字管理'
                    },
                    {
                        icon: 'el-icon-lx-group',
                        index: 'member',
                        title: '会员管理'
                    },

                    {
                        icon: 'el-icon-notebook-2',
                        index: 'editor',
                        title: '富文本编辑器'
                    },
                    {
                        icon: 'el-icon-connection',
                        index: 'mptool',
                        title: '微信素材'
                    },
                    /*
                                       {
                                           icon: 'el-icon-lx-calendar',
                                           index: '3',
                                           title: '表单相关',
                                           subs: [
                                               {
                                                   index: 'form',
                                                   title: '基本表单'
                                               },
                                               {
                                                   index: '3-2',
                                                   title: '三级菜单',
                                                   subs: [
                                                       {
                                                           index: 'editor',
                                                           title: '富文本编辑器'
                                                       },
                                                       {
                                                           index: 'markdown',
                                                           title: 'markdown编辑器'
                                                       }
                                                   ]
                                               },
                                               {
                                                   index: 'upload',
                                                   title: '文件上传'
                                               }
                                           ]
                                       },

                                       {
                                           icon: 'el-icon-lx-cascades',
                                           index: 'table',
                                           title: '基础表格'
                                       },
                                       {
                                           icon: 'el-icon-lx-copy',
                                           index: 'tabs',
                                           title: 'tab选项卡'
                                       },
                                       {
                                           icon: 'el-icon-lx-emoji',
                                           index: 'icon',
                                           title: '自定义图标'
                                       },
                                       {
                                           icon: 'el-icon-pie-chart',
                                           index: 'charts',
                                           title: 'schart图表'
                                       },
                                       {
                                           icon: 'el-icon-rank',
                                           index: '6',
                                           title: '拖拽组件',
                                           subs: [
                                               {
                                                   index: 'drag',
                                                   title: '拖拽列表'
                                               },
                                               {
                                                   index: 'dialog',
                                                   title: '拖拽弹框'
                                               }
                                           ]
                                       },
                                       {
                                           icon: 'el-icon-lx-global',
                                           index: 'i18n',
                                           title: '国际化功能'
                                       },
                                       {
                                           icon: 'el-icon-lx-warn',
                                           index: '7',
                                           title: '错误处理',
                                           subs: [
                                               {
                                                   index: 'permission',
                                                   title: '权限测试'
                                               },
                                               {
                                                   index: '404',
                                                   title: '404页面'
                                               }
                                           ]
                                       },
                                       {
                                           icon: 'el-icon-lx-redpacket_fill',
                                           index: '/donate',
                                           title: '支持作者'
                                       }*/
                ],
                items2:[
                    {
                        icon: 'el-icon-lx-home',
                        index: 'home',
                        title: '系统首页'
                    },
                    {
                        icon: 'el-icon-s-order',
                        index: 'order',
                        title: '订单管理'
                    },
                    {
                        icon: 'el-icon-lx-group',
                        index: 'member',
                        title: '会员管理'
                    },

                    {
                        icon: 'el-icon-notebook-2',
                        index: 'editor',
                        title: '富文本编辑器'
                    },
                   /*   {
                          icon: 'el-icon-lx-cascades',
                          index: 'table',
                          title: '基础表格'
                      },
                      {
                          icon: 'el-icon-lx-copy',
                          index: 'tabs',
                          title: 'tab选项卡'
                      },
                      {
                          icon: 'el-icon-lx-calendar',
                          index: '3',
                          title: '表单相关',
                          subs: [
                              {
                                  index: 'form',
                                  title: '基本表单'
                              },
                              {
                                  index: '3-2',
                                  title: '三级菜单',
                                  subs: [
                                      {
                                          index: 'editor',
                                          title: '富文本编辑器'
                                      },
                                      {
                                          index: 'markdown',
                                          title: 'markdown编辑器'
                                      }
                                  ]
                              },
                              {
                                  index: 'upload',
                                  title: '文件上传'
                              }
                          ]
                      },
                      {
                          icon: 'el-icon-lx-emoji',
                          index: 'icon',
                          title: '自定义图标'
                      },
                      {
                          icon: 'el-icon-pie-chart',
                          index: 'charts',
                          title: 'schart图表'
                      },
                      {
                          icon: 'el-icon-rank',
                          index: '6',
                          title: '拖拽组件',
                          subs: [
                              {
                                  index: 'drag',
                                  title: '拖拽列表'
                              },
                              {
                                  index: 'dialog',
                                  title: '拖拽弹框'
                              }
                          ]
                      },
                      {
                          icon: 'el-icon-lx-global',
                          index: 'i18n',
                          title: '国际化功能'
                      },
                      {
                          icon: 'el-icon-lx-warn',
                          index: '7',
                          title: '错误处理',
                          subs: [
                              {
                                  index: 'permission',
                                  title: '权限测试'
                              },
                              {
                                  index: '404',
                                  title: '404页面'
                              }
                          ]
                      },*/
                      {
                          icon: 'el-icon-lx-redpacket_fill',
                          index: '/donate',
                          title: '支持作者'
                      }
                ]
            };
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            }
        },
        created() {
            let userRole = sessionStorage.getItem('ml_role');
            console.log('userRole:'+userRole)
            if(userRole==7){
                this.items=this.items2;
            }
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
                bus.$emit('collapse-content', msg);
            });
        }
    };
</script>

<style scoped>
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom: 0;
        overflow-y: scroll;
    }

    .sidebar::-webkit-scrollbar {
        width: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 250px;
    }

    .sidebar > ul {
        height: 100%;
    }
</style>
